type KeywordInput = {
  word: string;
  required?: boolean | null;
};

type KeywordCombination = {
  key: number;
  word: string;
  required: null;
  length: number;
};

export const keywordsCombination = (
  keywords: KeywordInput[]
): KeywordCombination[] => {
  let counter = 1;
  const combinations: KeywordCombination[] = [];
  const requiredKeywords = keywords
    .filter(r => r.required === true)
    .map(r => r.word);
  const optionalKeywords = keywords
    .filter(r => r.required === false || r.required === null)
    .map(r => r.word);

  const prnPermut = (list: string[], k: number, m: number) => {
    if (k === m) {
      const word = list.join(' ');

      combinations.push({
        key: counter++,
        word,
        required: null,
        length: word.split(' ').filter(t => t !== '').length
      });
    } else {
      for (let i = k; i <= m; i++) {
        [list[k], list[i]] = [list[i], list[k]];
        prnPermut(list, k + 1, m);
        [list[k], list[i]] = [list[i], list[k]];
      }
    }
  };

  prnPermut(requiredKeywords, 0, requiredKeywords.length - 1);

  let newArrayWords = [...requiredKeywords, ...optionalKeywords];
  prnPermut(newArrayWords, 0, newArrayWords.length - 1);

  for (let i = 0; i < optionalKeywords.length; i++) {
    newArrayWords = [...requiredKeywords, optionalKeywords[i]];
    prnPermut(newArrayWords, 0, newArrayWords.length - 1);
    for (let j = 0; j < optionalKeywords.length; j++) {
      if (i !== j) {
        newArrayWords = [
          ...requiredKeywords,
          optionalKeywords[i],
          optionalKeywords[j]
        ];
        prnPermut(newArrayWords, 0, newArrayWords.length - 1);
      }
    }
  }

  combinations.sort((a, b) => a.length - b.length);
  return combinations;
};
